<footer *ngIf="!( isOnInit$ | async )" class="footer">
	<div class="footer-data">
		<div class="container">
			<div class="empty-panel"></div>

			<div class="social-panel-container">
				<img src="/assets/images/common/hi-isologo-negativo.png" class="hi-isologo" />

				<div class="social-panel">
					<div class="title">¡Seguinos!</div>
					<div class="social-icons-container">
						<a href="https://www.linkedin.com/company/hospital-italiano-de-buenos-aires" target="_blank" class="social-icon-link" gtagEvent="ver-linkedin" gtagCategory="footer">
							<svg fill="currentColor" class="linkedin" aria-hidden="true" focusable="false">
								<use href="#hi-icon-linkedin"></use>
							</svg>
						</a>
						<a href="https://www.facebook.com/hospitalitaliano.buenosaires" target="_blank" class="social-icon-link" gtagEvent="ver-facebook" gtagCategory="footer">
							<svg fill="currentColor" class="facebook" aria-hidden="true" focusable="false">
								<use href="#hi-icon-facebook"></use>
							</svg>
						</a>
						<a href="https://www.instagram.com/hospitalitalianodebuenosaires/" target="_blank" class="social-icon-link" gtagEvent="ver-instagram" gtagCategory="footer">
							<svg fill="currentColor" class="instagram" aria-hidden="true" focusable="false">
								<use href="#hi-icon-instagram"></use>
							</svg>
						</a>
						<a href="https://www.youtube.com/c/hibatvcanal" target="_blank" class="social-icon-link" gtagEvent="ver-youtube" gtagCategory="footer">
							<svg fill="currentColor" class="youtube" aria-hidden="true" focusable="false">
								<use href="#hi-icon-youtube"></use>
							</svg>
						</a>
					</div>
				</div>
			</div>

			<div class="social-sep"></div>

			<div class="direccion-panel-container">
				<div>
					<div class="title">Direcciones</div>
					<div>Hospital Italiano (sede Almagro)</div>
					<div>Tte. Gral. J. Domingo Perón 4190, CABA (C1199ABB)</div>
				</div>

				<div>
					<div>Hospital Italiano (sede San Justo Agustín Rocca)</div>
					<div>Av. Pte. J. Domingo Perón 2231, San Justo, Prov. de Buenos Aires (B1754AZK)</div>
				</div>
			</div>

			<div class="empty-panel"></div>
		</div>
	</div>

	<div class="footer-consumidor">
		<div class="container">
			<div class="empty-panel"></div>

			<a href="https://www.argentina.gob.ar/aaip/datospersonales" class="footer__image--item" target="_blank" gtagEvent="ver-datos-personales" gtagCategory="footer">
				<img src="/assets/images/footer/datos-personales.jpg">
			</a>
			<a href="https://www.buenosaires.gob.ar/defensaconsumidor" class="footer__image--item" target="_blank" gtagEvent="ver-defensa-consumidor" gtagCategory="footer">
				<img src="/assets/images/footer/defensa-consumidor.gif">
			</a>
			<a href="https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDU0NTg2NzY3OV1bdGlwb2RvbWljaWxpbz0wXVtzZWN1ZW5jaWE9MF1bdXJsPWh0dHA6Ly93d3cuaG9zcGl0YWxpdGFsaWFuby5vcmcuYXIvXX0=" class="footer__image--item" target="_blank">
				<img src="/assets/images/footer/servicios-web.jpg" gtagEvent="ver-servicios-web-afip" gtagCategory="footer">
			</a>

			<div class="empty-panel"></div>
		</div>
	</div>
</footer>
